// extracted by mini-css-extract-plugin
export default {"logo":"top_logo__U42yh","logo_placeholder":"top_logo_placeholder__smuNt"};